import Message from "../models/Messages";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class MessageTemplateService {
    parse(item) {
      console.log('item', item);
      
        return {
            id: item.id,
            templateName: item.template_name,
            templateId: item.template_id,
            localOnly: !item.template_id,
            category: item.template_type,
            body: item.body,
            copyCodeLabel: item.copy_code,
            ctaButtons: item.buttons,
            footer: item.footer,
            headerText: item.header,
            headerMedia: item.media_id,
            headerMediaType: item.media_type,
            language: item.language,
            variableSamples: item.variable_sample,
            status: item.status,
            templateQualityScore: item.template_quality_score,
            templateQualityPreviousScore: item.template_quality_previous_score,
            templateStatusReason: item.template_status_reason,
            updatedAt: item.updated_at,
            createdAt: item.created_at,
            updateAt: item.updated_at,
            mediaUrl: item.media_url,
            mediaId: item.media_id,
            headerType: item.header_type,
            template_layout: item.template_layout,
            carousel_cards: item.carousel_cards,
            otp_type: item.otp_type,
            add_security_recommendation: item.add_security_recommendation,
            code_expiration_minutes: item.code_expiration_minutes,
            supported_apps: item.supported_apps,
            autofill_text: item.autofill_text,
            catalog_id: item.catalog_id,
            product_retailer_ids: item.product_retailer_ids,
            multi_product_sections: item.multi_product_sections,
            product_button_text: item.product_button_text,
            appUsage: Array.isArray(item.app_usages) && item.app_usages[0]
              ? (item.app_usages.includes("all") ? "all" : item.app_usages[0])
              : (item.app_usage || "draft"),
            appUsages: Array.isArray(item.app_usages) && item.app_usages.length
              ? item.app_usages
              : [item.app_usage || "draft"],
            sourceDefaultTemplateId: item.source_default_template_id ?? null,
        }
    }

    async uploadCarouselCardMedia(cards = []) {
      const nextCards = [];
      for (const card of cards) {
        const copy = { ...card };
        if (copy.mediaFile) {
          const result = await this.uploadMediaNode(copy.mediaFile);
          copy.media_url = result.data[0].url;
          copy.media_id = result.data[0].id;
          copy.fileType = result.data[0].fileType;
        }
        delete copy.mediaFile;
        nextCards.push(copy);
      }
      return nextCards;
    }

    async createMessageTemplate(messageData) {
        
        if (messageData.headerMediaFile) {
            const result = await this.uploadMediaNode(messageData.headerMediaFile);
            messageData.mediaId = result.data[0].id;
            messageData.mediaUrl = result.data[0].url;
            messageData.mediaType = result.data[0].type;
            messageData.fileType = result.data[0].fileType;
        }
        if (messageData.templateLayout === "carousel_media" && Array.isArray(messageData.carouselCards)) {
            messageData.carouselCards = await this.uploadCarouselCardMedia(messageData.carouselCards);
        }
        console.log('messageData', messageData);
        const url = `/message/template/${appConfig.getServiceId()}`;
        const { data } = await request.post(url, messageData);
        return data;
    }

    async updateMessageTemplate(messageData) {
        if (messageData.onlyAppUsage) {
            const url = `template/${appConfig.getServiceId()}`;
            const { data } = await request.put(url, {
                id: messageData.id,
                appUsage: messageData.appUsage,
                appUsages: messageData.appUsages,
                onlyAppUsage: true,
            });
            return data;
        }
        messageData.deleteMediaId = null;
        if (messageData.headerMediaFile != null) {
          if (messageData.mediaId != null) {
              messageData.deleteMediaId = messageData.mediaId;
          }
            const result = await this.uploadMediaNode(messageData.headerMediaFile);
            messageData.mediaId = result.data[0].id;
            messageData.mediaUrl = result.data[0].url;
            messageData.mediaType = result.data[0].type;
            messageData.fileType = result.data[0].fileType;
        }
        if (messageData.templateLayout === "carousel_media" && Array.isArray(messageData.carouselCards)) {
            messageData.carouselCards = await this.uploadCarouselCardMedia(messageData.carouselCards);
        }
        console.log('messageData', messageData);
        const url = `template/${appConfig.getServiceId()}`;
        const { data } = await request.put(url, messageData);
        return data;
    }
    async getAllTemplates() {
        const url = `/message/templates/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        return data.map((model) => new Message(this.parse(model)));
    }

    async syncMessageTemplateToMeta(templateId) {
        const url = `/message/template/${appConfig.getServiceId()}/sync`;
        const { data } = await request.post(url, { id: templateId });
        return data;
    }

    async duplicateTemplate(templateId) {
        const url = `/message/template/${appConfig.getServiceId()}/duplicate`;
        const { data } = await request.post(url, { id: templateId });
        return data;
    }

    async getDefaultTemplates() {
        const data = await request.get('/message/template/defaults/list');
        return Array.isArray(data) ? data : [];
    }

    async cloneDefaultTemplate(defaultId, serviceId) {
        const sid = serviceId || appConfig.getServiceId();
        return request.post(`/message/template/defaults/${defaultId}/clone/${sid}`);
    }

    async uploadMediaNode(file) {
    console.log("servicefile", file);
    const formData = new FormData();
    formData.append("files", file);
    formData.append("name", file.name);
    formData.append("type", file.type);
    formData.append("service_id", appConfig.getServiceId());
    console.log("formData", formData);

    try {
      const response = await request.post(
        `/upload-media/${appConfig.getServiceId()}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(`Media uploaded successfully:`, response);
      return response;
    } catch (error) {
      console.error(`Error uploading media:`, error);
      throw error;
    }
  }
}
export default new MessageTemplateService();